// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1KyJd","header":"PatientBlock_header__19EeW","label":"PatientBlock_label__1COKk","option":"PatientBlock_option__1wPtn"};